import { request } from "../../apis";

export const apiGetTeamList = (params) => request("get", `/user/team_list`, params, true);

export const apiGetTeamListDetail = (params) =>
  request("get", `/user/team_list_detail`, params, true);
